import {Link} from 'react-router';
import React from 'react';

export const isActive = (location, item) => {
  return item.otherActiveUrls && item.otherActiveUrls.find(o => location.pathname.startsWith(o));
};

const DefaultNavRenderer = ({item, location}) => (
  <span className="navbar-link-wrapper">
    <Link
      to={item.url}
      className={isActive(location, item) ? 'active' : ''}
      activeClassName="active"
      onlyActiveOnIndex={item.onlyActiveOnIndex}>
      {item.name}
    </Link>
  </span>
);

export default DefaultNavRenderer;
